module.exports = __webpack_public_path__ + "static/media/CanBeSeenBadOptimized.926e6f05.jp2";